import { and, eq, getTableColumns, inArray } from "drizzle-orm";

import { db } from "@/db/db.ts";
import { feed, fleetGroup, fleetGroupItem, permission } from "@/db/schema.ts";
import { emptyQuery } from "@/models/emptyQuery.ts";
import { logQuery } from "@/models/logQuery.ts";

export function fleetGroupQuery({ workspaceId }: { workspaceId: string }) {
  const query = db
    .select({
      ...getTableColumns(fleetGroup),
    })
    .from(fleetGroup)
    .where(eq(fleetGroup.workspaceId, workspaceId))
    .orderBy(fleetGroup.name);

  if (!workspaceId) {
    return emptyQuery as unknown as typeof query;
  }
  logQuery("Groups", query);
  return query;
}

export const fleetGroupWithItemsQuery = ({
  ids,
  workspaceMembershipId,
}: {
  ids: string[];
  workspaceMembershipId: string;
}) => {
  if (!ids || ids.length === 0 || !workspaceMembershipId) {
    return emptyQuery as unknown as typeof query;
  }
  const query = db
    .select({
      id: fleetGroupItem.id,
      feedId: fleetGroupItem.feedId,
      fleetGroupId: fleetGroupItem.fleetGroupId,
      feedName: feed.title,
    })
    .from(fleetGroupItem)
    .innerJoin(feed, eq(feed.id, fleetGroupItem.feedId))
    .innerJoin(permission, eq(permission.feedId, feed.id))
    .where(
      and(
        inArray(fleetGroupItem.fleetGroupId, ids),
        eq(permission.name, "write"),
        eq(permission.enabled, true),
        eq(permission.workspaceMembershipId, workspaceMembershipId),
      ),
    );

  logQuery("ids", query);
  return query;
};

export const removeFleetGroupById = async (id: string): Promise<void> => {
  await db.delete(fleetGroupItem).where(eq(fleetGroupItem.fleetGroupId, id)).execute();
  await db.delete(fleetGroup).where(eq(fleetGroup.id, id));
};
